import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api";

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-radius: 10px;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 100px;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  height: 38px;
`;

const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
`;

const Button = styled.button`
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 6px;
  border: none;
  background-color: #2980b9;
  color: white;
  height: 38px;
  font-size: 14px;
  font-weight: 600;
  align-self: flex-end;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  height: 38px;
  background: #fff;
`;

const FormRodada = ({ getUsers, onEdit, setOnEdit, onLigaChange }) => {
  const ref = useRef();
  const [ligas, setLigas] = useState([]);
  const [idLigaSelecionada, setIdLigaSelecionada] = useState("");
  const [idRodada, setIdRodada] = useState(0);

  useEffect(() => {
    api.get("liga/listarLigas")
      .then(({ data }) => {
        setLigas(data);
        if (data.length > 0) {
          setIdLigaSelecionada(data[0].id);
          if (onLigaChange) onLigaChange(data[0].id);
        }
      })
      .catch(() => toast.error("Erro ao carregar ligas"));
  }, []);

  useEffect(() => {
    if (onEdit) {
      const user = ref.current;
      setIdRodada(onEdit.id);
      user.rodada.value = onEdit.rodada;
      user.valorParticipante.value = onEdit.valorParticipante;
      user.valorRodada.value = onEdit.valorRodada;
      user.visivel.checked = onEdit.visivel;
      if (onEdit.idLiga) setIdLigaSelecionada(onEdit.idLiga);
    }
  }, [onEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = ref.current;

    if (!user.rodada.value || !user.valorParticipante.value || !user.valorRodada.value || !idLigaSelecionada) {
      return toast.warn("Preencha todos os campos obrigatórios!");
    }

    const req = {
      id: idRodada,
      rodada: Number(user.rodada.value),
      idLiga: Number(idLigaSelecionada),
      valorParticipante: Number(user.valorParticipante.value),
      valorRodada: Number(user.valorRodada.value),
      visivel: user.visivel.checked,
    };

    await api.post("liga/addRodada", req)
      .then(({ data }) => toast.success(data))
      .catch(({ data }) => toast.error(data));

    setIdRodada(0);
    user.rodada.value = "";
    user.valorParticipante.value = "";
    user.valorRodada.value = "";
    user.visivel.checked = false;

    setOnEdit(null);
    getUsers(idLigaSelecionada);
  };

  return (
    <FormContainer ref={ref} onSubmit={handleSubmit}>
      <Row>
        <InputArea>
          <Label>Liga *</Label>
          <Select value={idLigaSelecionada} onChange={(e) => { setIdLigaSelecionada(e.target.value); if (onLigaChange) onLigaChange(e.target.value); }}>
            {ligas.map((l) => (
              <option key={l.id} value={l.id}>{l.nome} ({l.ano})</option>
            ))}
          </Select>
        </InputArea>
      </Row>
      <Row>
        <InputArea style={{ minWidth: 80, maxWidth: 90 }}>
          <Label>Rodada *</Label>
          <Input name="rodada" type="number" min="1" />
        </InputArea>
        <InputArea style={{ minWidth: 130 }}>
          <Label>Vl Participante *</Label>
          <Input name="valorParticipante" type="number" step="0.01" placeholder="0,00" />
        </InputArea>
        <InputArea style={{ minWidth: 130 }}>
          <Label>Vl Rodada *</Label>
          <Input name="valorRodada" type="number" step="0.01" placeholder="0,00" />
        </InputArea>
        <InputArea style={{ minWidth: 60, maxWidth: 64, alignItems: "center", justifyContent: "flex-end" }}>
          <Label>Visível</Label>
          <input name="visivel" type="checkbox" style={{ width: 20, height: 20, marginBottom: 2 }} />
        </InputArea>
        <Button type="submit" style={{ alignSelf: "flex-end" }}>Salvar</Button>
      </Row>
    </FormContainer>
  );
};

export default FormRodada;

